import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        { text: ["2xs", "xs", "sm", "base", "lg", "xl", "2xl", "3xl"] }
      ],
      "text-size": [
        { text: ["2xs", "xs", "sm", "base", "lg", "xl", "2xl", "3xl", "4xl", "5xl", "6xl"] }
      ],
      "letter-spacing": [
        { tracking: ["sidebar"] }
      ],
    },
  },
});

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}